import { GridItem } from '@bnnvara/grids';
import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from '@/components/Accordion';

const ComposableAccordion = ({ id, items, title }) => (
  <GridItem
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
  >
    <Accordion id={id} items={items} title={title} />
  </GridItem>
);

ComposableAccordion.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      subject: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      expanded: PropTypes.bool,
    })
  ).isRequired,
};

export default ComposableAccordion;
